import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { Search } from "./SidebarRight";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IonIcon, IonToolbar } from "@ionic/react";
import {
  bookmarkOutline,
  carOutline,
  cartOutline,
  lockClosedOutline,
  mail,
  mailOpenOutline,
  mailOutline,
  notificationsOutline,
  peopleOutline,
} from "ionicons/icons";

const Icon = () => {
  return <img src="/logo.jpeg" alt="icon" width={30} height={30} />;
};

// const HomeLink = () => {
//   return (
//     <Link className="homelink" to="/">
//       <Icon />
//     </Link>
//   );
// };

export const useHeaderTitle = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const path = location.pathname.split("/")[1];

  const titleMap = {
    trending: "Community",
    study: "LoonLearn",
    alerts: "Alerts",
    bookmarks: "Bookmarks",
    messages: "Messages",
    friends: "Friends",
    videos: "Videos",
    market: "Local Market",
    loonlock: "LoonLock",
    email: "Email",

    explore: "Explore",
    travel: "Travel",
    students: "Students",
    exams: "Exams",
    ride: "Ride",
    profile: "Profile",
    settings: "Settings",
    post: "Post",
    ai: "AI",
    edit: "Edit",
    search: "Search",
    mail: "LoonMail",
  };

  const titleKey = titleMap[path];
  const title = titleKey ? t(titleKey) : "LoonLog";

  return title;
};

function Header({ hashtagTitle, endSlot }) {
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const titleMap = {
    explore: "Explore",
    home: "Home",
    travel: "Travel",
    students: "Students",
    exams: "Exams",
    ride: "Ride",
    alerts: "Alerts",
    messages: "Messages",
    bookmarks: "Bookmarks",
    friends: "Friends",
    market: "Local Market",
    profile: "Profile",
    settings: "Settings",
    post: "Post",
    ai: "AI",
    videos: "Videos",
    trending: "Community",
    edit: "Edit",
    search: "Search",
    mail: "LoonMail",
  };

  const titleKey = titleMap[path] || path;
  const title = t(titleKey);

  if (path === "home" || path === "post") return <div></div>;

  return (
    <IonToolbar>
      <header
        className="header display-flex align-items-c justify-content-sb header-font"
        style={{ justifyContent: "flex-start" }}
      >
        {/* {path === "trending" ? <></> : <></>} */}
        {path === "trending" ? (
          <Fragment>
            <div className="show-on-desktop">
              <h3>{t("Trending")}</h3>
            </div>
            <div className="show-on-mobile" style={{ flex: "1" }}>
              <Search />
            </div>
          </Fragment>
        ) : path === "friends" ? (
          <Fragment>
            <div className="show-on-desktop">
              <h3>{t("Friends")}</h3>
            </div>
            <div className="show-on-mobile" style={{ flex: "1" }}>
              <Search />
            </div>
          </Fragment>
        ) : // <div style={{ display: "flex", alignItems: "center", color: "red", gap: "7px" }}>
        //   <IonIcon icon={peopleOutline} />

        //   <h3
        //     style={{ display: "inline", fontWeight: "lighter" }}
        //   >
        //     {t("Friends")}
        //   </h3>

        // </div>
        path === "ai" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <h3
              style={{ display: "inline", color: "red", fontWeight: "normal" }}
            >
              LoonAi
            </h3>
            <i>
              <small style={{ fontSize: "14px" }}>
                • Local AI. Open Community.
              </small>
            </i>
          </div>
        ) : path === "ride" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <IonIcon icon={carOutline} style={{ color: "red" }} />
            <h3
              style={{ display: "inline", color: "red", fontWeight: "lighter" }}
            >
              {t("ride")}
            </h3>
            <i>
              {/* <p style={{ fontSize: "14px" }}>
                  Neighbourhood Ride Network
                </p> */}
              <p style={{ fontSize: "14px", alignSelf: "flex-end" }}>
                {t("rideTagLine")}
              </p>
            </i>
          </div>
        ) : path === "market" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <IonIcon icon={cartOutline} style={{ color: "red" }} />
            <h3
              style={{
                display: "inline-block",
                color: "red",
                fontWeight: "normal",
                paddingBottom: "3px",
              }}
            >
              {t("localFinds")}
            </h3>
            {/* <div>
                <i>
                  <p style={{ fontSize:"14px", }}>
                    Buy/Sell - From Shopkeepers & Regular Folks
                  </p>
                </i>
               
              </div> */}
          </div>
        ) : path === "exams" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <h3
              style={{ display: "inline", color: "red", fontWeight: "normal" }}
            >
              Exams
            </h3>
            <i>
              <small style={{ fontSize: "14px" }}>
                • The Pass-Together Community.
              </small>
            </i>
          </div>
        ) : path === "students" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <h3
              style={{ display: "inline", color: "red", fontWeight: "normal" }}
            >
              Students{" "}
            </h3>
            <i>
              <small style={{ fontSize: "14px" }}>• Higher Together.</small>
            </i>
          </div>
        ) : path === "loonlock" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <IonIcon icon={lockClosedOutline} style={{ color: "red" }} />

            <h3
              style={{
                display: "inline",
                color: "red",
                fontWeight: "lighter",
                paddingBottom: "3px",
              }}
            >
              LoonLock{" "}
            </h3>
            {/* <i>
                <small style={{ fontSize: "14px" }}>
                  Encrypted Document Sharing Feature

                </small>
              </i> */}
          </div>
        ) : path === "study" ? (
          <>
            <i>
              <small style={{ fontSize: "18px" }}>
                {" "}
                Where Learning Gets Social, Eh.
              </small>
            </i>
          </>
        ) : path === "alerts" ? (
          <div
            style={{
              display: "flex",
              color: "red",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <IonIcon icon={notificationsOutline} />

            <h3 style={{ display: "inline", fontWeight: "lighter" }}>
              {t("Alerts")}
            </h3>
            <i></i>
          </div>
        ) : path === "bookmarks" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <IonIcon icon={bookmarkOutline} style={{ color: "red" }} />

            <h3
              style={{ display: "inline", color: "red", fontWeight: "lighter" }}
            >
              {t("Bookmarks")}
            </h3>
            <i></i>
          </div>
        ) : path === "messages" ? (
          <Fragment>
            <div className="show-on-desktop">{t("Messages")}</div>
            <div className="show-on-mobile" style={{ flex: "1" }}>
              <Search />
            </div>
          </Fragment>
        ) : path.startsWith("hashtag") ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "red",
              gap: "7px",
            }}
          >
            <IonIcon icon={peopleOutline} />

            <h3 style={{ display: "inline", fontWeight: "lighter" }}>
              {hashtagTitle ||
                location.pathname.split("/").pop().charAt(0).toUpperCase() +
                  location.pathname.split("/").pop().slice(1)}
            </h3>
          </div>
        ) : path === "email" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "red",
              gap: "7px",
            }}
          >
            <IonIcon icon={mailOpenOutline} />

            <h3 style={{ display: "inline", fontWeight: "lighter" }}>Email</h3>
          </div>
        ) : (
          <h3 style={{ color: "red", fontWeight: "lighter" }}>{title}</h3>
        )}
      </header>
      {endSlot}
    </IonToolbar>
  );
}

export default Header;

